import React, { useId } from 'react'
import {
  RadioProvider,
  StandardRadio,
} from '../../ui_reusable/StandardRadioButtons'
import { StandardCheckbox } from '../../ui_reusable/StandardInputs'
import {
  FilterRadioRow,
  FilterRadioLabel,
} from '../../ui_reusable/styles/VersatileGridUtils.styles'

interface DriverSelectionFilterProps {
  showSelectedOnly: boolean
  onChange: (showSelectedOnly: boolean) => void
  availableFirst?: boolean
  onAvailableFirstChange?: (availableFirst: boolean) => void
}

// Implementation kept; hide until sort-by-active is fast enough to ship.
const SHOW_SORT_BY_ACTIVE = false

const DriverSelectionFilter: React.FC<DriverSelectionFilterProps> = ({
  showSelectedOnly,
  onChange,
  availableFirst = false,
  onAvailableFirstChange,
}) => {
  const group = `driver-selected-filter-${useId()}`

  return (
    <RadioProvider
      group={group}
      initValue={showSelectedOnly ? 'selected' : 'all'}
      onChange={(value) => onChange(value === 'selected')}
    >
      <FilterRadioRow data-testid="driver-selected-filter">
        <FilterRadioLabel>
          <StandardRadio size="m" group={group} value="all" />
          All
        </FilterRadioLabel>
        <FilterRadioLabel>
          <StandardRadio size="m" group={group} value="selected" />
          Selected
        </FilterRadioLabel>
        {SHOW_SORT_BY_ACTIVE && onAvailableFirstChange && (
          <FilterRadioLabel>
            <StandardCheckbox
              checked={availableFirst}
              onChange={(event) =>
                onAvailableFirstChange(event.target.checked)
              }
              data-testid="available-first-filter"
            />
            Sort by active
          </FilterRadioLabel>
        )}
      </FilterRadioRow>
    </RadioProvider>
  )
}

export default DriverSelectionFilter
